import { Directive, OnChanges, EventEmitter, Output, Input, SimpleChanges, ElementRef, HostListener, HostBinding } from '@angular/core';

// To add placeholder use css like this:
//
// [contentEditable] {
//    padding-left: 1px;
//    margin-left: -1px;
// }
// [placeholder]:empty:not(:focus):before {
//     content: attr(placeholder);
//     font-style: italic;
//     color: #aaaaaa;
//     cursor: text;
// }

@Directive({
    selector: '[contenteditableModel]',
})
export class ContenteditableModelDirective implements OnChanges {

    /**
     * Define two-way binding input/output model
     */
    @Input('model') model: any;
    @Output() modelChange = new EventEmitter<any>();

    @HostBinding('attr.contenteditable') contenteditable: boolean = true;

    @Input('enable') set setEnable(enabled) {
        this.contenteditable = (enabled != undefined && enabled != null && enabled != false);
    }
    private lastViewModel: any;

    constructor(private elRef: ElementRef) {
    }


    @HostListener("blur", ['$event.target']) onBlur(ev) {
        // console.log("Blur ", this.elRef.nativeElement.innerText);
        let value = this.elRef.nativeElement.innerText;
        //console.log("Blur word value '" + value + "' last '" + this.lastViewModel + "'");
        if(this.lastViewModel == value) return;
        // Notify listners
        this.lastViewModel = value;
        this.modelChange.emit(value);
    }

    @HostListener("keyup", ['$event.target']) onKeyup(ev) {
        //console.log("Key up in child ", ev);
        let value = this.elRef.nativeElement.innerText;
        //console.log("Key up word value '" + value + "' last '" + this.lastViewModel + "'");
        if(this.lastViewModel == value) return;
        // Notify listners
        this.lastViewModel = value;
        this.modelChange.emit(value);
    }

    @HostListener("keydown", ['$event']) onKeydown(ev) {
        // If backspace was fired on first position in a element without content editable sibling ignore delete event
        if(ev.code == "Backspace" && (!ev.target.previousSibling || !ev.target.previousSibling.contentEditable) && this.getCaretPos(ev.target) == 0) {
            console.log("Previous ", ev.target.previousSibling);
            ev.preventDefault();
            ev.stopPropagation();
        }
        // console.log("Ev", ev);
        // Prevent new lines
        if(ev.code == "Enter") {
            ev.preventDefault();
            ev.stopPropagation();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // console.log("Angular change ", changes);
        if(changes != this.lastViewModel) {
            this.lastViewModel = this.model;
            this.refreshView();
        }
    }

    onRemove(ev) {
        // Save empty string in model
        this.modelChange.emit("");
        return ev;
    }

    private refreshView() {
        // console.log("Old vallue: ", this.elRef.nativeElement.innerText, this.model );
        if(this.elRef.nativeElement.innerText == this.model) return;
        this.elRef.nativeElement.innerText = this.model;
    }

    private getCaretPos(ele) {
        // for contentedit field
        let range = document.getSelection().getRangeAt(0);
        let rangeClone = range.cloneRange();
        rangeClone.selectNodeContents(ele);
        rangeClone.setEnd(range.endContainer, range.endOffset);
        return rangeClone.toString().length;
    }
}
